var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"timer",class:_vm.state},[_c('div',{staticClass:"bar",style:({ width: (_vm.seconds / _vm.total) * 100 + '%' })}),_c('span',[_vm._v(_vm._s(_vm.time))])])}
var staticRenderFns = []

export { render, staticRenderFns }